var React = require('react');

function IconTwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.6 17.856L32.776 6h-2.411l-8.836 10.294L14.473 6h-8.14l10.672 15.567L6.333 34h2.412l9.33-10.871L25.528 34h8.139L22.6 17.856zm-3.302 3.848l-1.082-1.55L9.614 7.82h3.703l6.943 9.954 1.081 1.55 9.025 12.94h-3.704l-7.364-10.56z"}));
}

IconTwitterInline.defaultProps = {"width":"40","height":"40"};

module.exports = IconTwitterInline;

IconTwitterInline.default = IconTwitterInline;
